module.exports = __webpack_public_path__ + "static/media/image-wednesday.4ade3449.jpg";